import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Button, Dropdown, DropdownMenuItem} from 'views/components';
import {Translate, translate} from 'views/module';

const Content = (props) => {
  const BILLING_METHOD_OPTIONS = ['MANUAL', 'AUTO_CHARGE'];

  const [newBillingMethod, setNewBillingMethod] = React.useState('MANUAL');
  const [isSaving, setIsSaving] = React.useState(false);

  const clientPaymentPlan = props.clientPaymentPlan;
  const updateClientBillingMethod = props.updateClientBillingMethod;
  const setViewMode = props.setViewMode;

  React.useEffect(() => {
    if (clientPaymentPlan && clientPaymentPlan.billingMethod != null) {
      setNewBillingMethod(clientPaymentPlan.billingMethod);
    } else {
      setNewBillingMethod('MANUAL');
    }
  }, [clientPaymentPlan]);

  const onSave = () => {
    setIsSaving(true);
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateClientBillingMethod(newBillingMethod, onSuccess);
  };

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        'display': 'flex',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentPlan.BillingMethodTitle'
          />
        </Typography>
      </Box>
      <Box>
        <Dropdown
          value={newBillingMethod}
          onChange={setNewBillingMethod}
        >
          {BILLING_METHOD_OPTIONS.map((billingMethodKey) => {
            return (
              <DropdownMenuItem key={billingMethodKey} value={billingMethodKey}>
                {translate(`client.ClientDetail.Payment.PaymentPlan.BillingMethod.Options.${billingMethodKey}`)}
              </DropdownMenuItem>
            );
          })}
        </Dropdown>
      </Box>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
        >
          <Translate expression='generic.Save' />
        </Button>
      </Stack>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  updateClientBillingMethod: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
